import Info from '../info/info'
import HeaderSteps from '../header-steps/header-steps'
import { useCategoryTitle } from '../../../contexts/category-farm-context'
import { Container } from './styles'
import { matchPath } from 'react-router'
import { translate } from '../../../../i18n/index'

const InfoBar = () => {
  const { categoryTitle } = useCategoryTitle()
  const farmName = window.localStorage.getItem('farm-name') ? atob(window.localStorage.getItem('farm-name')) : ''
  const farmKey = window.localStorage.getItem('farm-api-key') ? atob(window.localStorage.getItem('farm-api-key')) : ''

  const titlePageCustom = categoryTitle?.title

  const categories = [
    {
      title: translate('btnFichaVaca'),
      slug: '/ubere/ficha-da-vaca'
    },
    {
      title: `${titlePageCustom}`,
      slug: '/rastreio-de-pedidos/:id'
    },
    {
      title: `${titlePageCustom}`,
      slug: '/minhas-contas/:id'
    },
    {
      title: `${titlePageCustom}`,
      slug: '/bezerra/tarefa/:id'
    },
    {
      title: `${titlePageCustom}`,
      slug: '/ubere/ficha-da-vaca/:id'
    },
    {
      title: 'Adicionar Tratamento',
      slug: '/ubere/adicionar-tratamento/:id'
    },
    {
      title: translate('labelResultados'),
      slug: '/ubere/resultados'
    },
    {
      title: translate('labelResultados'),
      slug: '/ubere/resultados/:id'
    },
    {
      title: 'Reprocessar',
      slug: '/ubere/reprocessar/:id'
    },
    {
      title: translate('labelTratamentos'),
      slug: '/ubere/tratamentos'
    },
    {
      title: translate('labelNovoTratamento'),
      slug: '/ubere/novo-tratamento'
    },
    {
      title: translate('labelTratamentos'),
      slug: '/ubere/tratamentos/:id'
    },
    {
      title: translate('labelTratamentos'),
      slug: '/ubere/tratamentos/compartilhar/:id'
    },
    {
      title: translate('labelAnaliseCbtTanque'),
      slug: '/ubere/analise-cbt-tanque'
    },
    {
      title: translate('labelAnaliseCbtTanque'),
      slug: '/ubere/analise-cbt-tanque/:id'
    },
    {
      title: 'Relatórios',
      slug: '/ubere/relatorios'
    },
    {
      title: translate('labelRelatóriosProcessados'),
      slug: '/ubere/relatorios-processados'
    },
    {
      title: translate('labelGrafico'),
      slug: '/ubere/graficos'
    },
    {
      title: translate('labelOcorrenciaMastiteClinica'),
      slug: '/ubere/grafico-ocorrencia-mastite-clinica'
    },
    {
      title: translate('labelIncidenciaMastiteClinica'),
      slug: '/ubere/grafico-incidencia-mastite-clinica'
    },
    {
      title: translate('labelFrequenciaCrescimento'),
      slug: '/ubere/grafico-frequencia-de-crescimento'
    },
    {
      title: translate('labelPrevalencaAgentes'),
      slug: '/ubere/grafico-prevalencia-de-agentes'
    },
    {
      title: translate('labelPrevalenciaGrupoGRAM'),
      slug: '/ubere/grafico-por-grupo-gram'
    },
    {
      title: translate('labelCuraClinica'),
      slug: '/ubere/grafico-cura-clinica'
    },
    {
      title: translate('labelCuraClinicaPorTratamento'),
      slug: '/ubere/grafico-cura-clinica-por-tratamento'
    },
    {
      title: translate('labelCuraClinicaDiagnóstico'),
      slug: '/ubere/grafico-cura-clinica-por-diagnostico'
    },
    {
      title: 'Comunidade Onfarmers',
      slug: '/ubere/comunidade-onfarmes'
    },
    {
      title: 'OnFarms Benchmarking',
      slug: '/ubere/top-5-intramamarios'
    },
    {
      title: 'OnFarms Benchmarking',
      slug: '/ubere/top-5-injetaveis'
    },
    {
      title: 'OnFarms Benchmarking',
      slug: '/ubere/top-5-anti-inflamatorios'
    },
    {
      title: 'OnFarms Benchmarking',
      slug: '/ubere/top-5-intramamario-por-agentes'
    },
    {
      title: 'OnFarms Benchmarking',
      slug: '/ubere/dias-tratamento-intramamario-por-agentes'
    },
    {
      title: 'OnFarms Benchmarking',
      slug: '/ubere/cura-clinica'
    },
    {
      title: 'OnFarms Benchmarking',
      slug: '/ubere/incidencia-mastite-clinica'
    },
    {
      title: translate('labelTarefas'),
      slug: '/ubere/minhas-tarefas'
    },
    {
      title: `${titlePageCustom}`,
      slug: '/ubere/tarefa/:id'
    },
    {
      title: translate('btnExameMicrobiologico'),
      slug: '/ubere/exame-microbiologico'
    },
    {
      title: translate('btnExameMicrobiologico'),
      slug: '/ubere/exame-microbiologico/:id'
    },
    {
      title: translate('labelNovaMastiteClinicaSemCultura'),
      slug: '/ubere/nova-mastite-clinica-sem-exame'
    },
    {
      title: translate('labelNovaMastiteClinicaSemCultura'),
      slug: '/ubere/nova-mastite-clinica-sem-exame/:id'
    },
    {
      title: translate('labelAnaliseCbtTanque'),
      slug: '/ubere/new-analise-cbt-tanque'
    },
    {
      title: 'Leitura da Placa',
      slug: '/ubere/leitura-de-resultados'
    },
    {
      title: translate('labelRevisarLeituraAutomatica'),
      slug: '/ubere/review-automatic-readings'
    },
    {
      title: translate('labelLancamentoMastiteLote'),
      slug: '/ubere/mass-launches'
    },
    {
      title: 'Leitura da Placa',
      slug: '/ubere/leitura-de-resultados/:id'
    },
    {
      title: 'Importação de dados',
      slug: '/ubere/importacao-de-dados'
    },
    {
      title: 'Banco de colostro',
      slug: '/bezerra/banco-de-colostro'
    },
    {
      title: 'Banco de colostro',
      slug: '/bezerra/novo-colostro/:id'
    },
    {
      title: 'Colostragem',
      slug: '/bezerra/colostragem'
    },
    {
      title: 'Colostragem',
      slug: '/bezerra/nova-colostragem/:id'
    },
    {
      title: 'Colostragem',
      slug: '/bezerra/colostragem/:id'
    },
    {
      title: translate('labelTratamentos'),
      slug: '/bezerra/tratamentos'
    },
    {
      title: translate('labelTratamentos'),
      slug: '/bezerra/tratamentos/:id'
    },
    {
      title: translate('labelTratamentos'),
      slug: '/bezerra/tratamentos/compartilhar/:id'
    },
    {
      title: translate('labelNovoTratamento'),
      slug: '/bezerra/novo-tratamento'
    },
    {
      title: 'Doenças',
      slug: '/bezerra/doencas'
    },
    {
      title: 'Nova Doença',
      slug: '/bezerra/nova-doenca'
    },
    {
      title: 'Doenças',
      slug: '/bezerra/nova-doenca/:id'
    },
    {
      title: 'Adicionar Tratamento',
      slug: '/bezerra/adicionar-tratamento/:id'
    },
    {
      title: 'Ficha da bezerra',
      slug: '/bezerra/ficha-da-bezerra'
    },
    {
      title: `${titlePageCustom}`,
      slug: '/bezerra/ficha-da-bezerra/:id'
    },
    {
      title: translate('labelGrafico'),
      slug: '/bezerra/graficos'
    },
    {
      title: 'Qualidade de colostro (CBT)',
      slug: '/bezerra/qualidade-colostro'
    },
    {
      title: 'Qualidade de colostro (BRIX)',
      slug: '/bezerra/qualidade-colostro-brix'
    },
    {
      title: 'Qualidade de colostro (lgG e CBT)',
      slug: '/bezerra/qualidade-colostro-lgG-cbt'
    },
    {
      title: 'Qualidade de colostragem',
      slug: '/bezerra/qualidade-colostragem'
    },
    {
      title: translate('labelTarefas'),
      slug: '/bezerra/minhas-tarefas'
    },
    {
      title: 'Novo colostro',
      slug: '/bezerra/novo-colostro'
    },
    {
      title: 'Relatórios',
      slug: '/bezerra/relatorios'
    },
    {
      title: translate('labelRelatóriosProcessados'),
      slug: '/bezerra/relatorios-processados'
    },
    {
      title: 'Nova colostragem',
      slug: '/bezerra/nova-colostragem'
    },
    {
      title: translate('labelTratamentos'),
      slug: '/bezerra/tratamento/:id'
    },
    {
      title: translate('labelLeituraResultados'),
      slug: '/bezerra/leitura-de-resultados'
    },
    {
      title: translate('labelDadosUsuario'),
      slug: '/meus-dados/dados-do-usuario'
    },
    {
      title: 'Dados da fazenda',
      slug: '/meus-dados/dados-da-fazenda'
    },
    {
      title: translate('labelMinhasContas'),
      slug: '/minhas-contas'
    },
    {
      title: translate('labelRastreioPedidos'),
      slug: '/rastreio-de-pedidos'
    },
    {
      title: 'Lactação',
      slug: '/lactacao'
    },
    {
      title: 'Lactação',
      slug: '/lactacao/:id'
    },
    {
      title: 'Nova Lactação',
      slug: '/nova-lactacao'
    },
    {
      title: translate('labelArtigosVideos'),
      slug: '/artigos-e-videos'
    },
    {
      title: translate('labelArtigosVideos'),
      slug: '/video'
    },
    {
      title: translate('labelArtigosVideos'),
      slug: '/video/:id'
    },
    {
      title: translate('labelUsuarios'),
      slug: '/usuarios'
    },
    {
      title: translate('labelUsuarios'),
      slug: '/usuarios/:id'
    },
    {
      title: translate('labelNovoUsuario'),
      slug: '/novo-usuario'
    },
    {
      title: translate('labelFazendas'),
      slug: '/fazendas'
    },
    {
      title: translate('labelFazendas'),
      slug: '/fazendas/:id'
    },
    {
      title: translate('labelNovaFazenda'),
      slug: '/nova-fazenda'
    },
    {
      title: 'Token',
      slug: '/token'
    },
    {
      title: translate('labelIntegracaoParceiros'),
      slug: '/integracao-parceiros'
    },
    {
      title: translate('labelCentralNotificacao'),
      slug: '/central-de-notificacoes'
    },
    {
      title: translate('labelLeituraResultados'),
      slug: '/ubere/anexo-da-placa/:id'
    }
  ]

  const items = categories.filter((item) => matchPath(location.pathname, { path: item.slug, exact: true, strict: false }))

  return (
    <Container>

      <div className="info-bar">
        <HeaderSteps params={categoryTitle} />

        <div>
          <div className="info-bar-text">
            {items.map((category) => (
              <h1 key={category.slug}>{category.title}</h1>
            ))}
            <h4>#{farmKey} - {farmName}</h4>
          </div>
        </div>

        <Info />
      </div>
    </Container>
  )
}

export default InfoBar
